import React from "react";

function Experts() {
  return (
    <>
      <section className="trusted_by ps ">
        <div className="container">
          <h2 className="hadding mb-3 text-center">
            Trusted by Experts. Backed by Science.
          </h2>
          <p className="mb-3 text-center mb-4 mb-md-5">
            Access experts who guide you through your health journey.
          </p>
          <div className="row ">
            <div className="col-6 col-lg-3 mb-3" data-aos="fade-up">
              <div className="trusted_by_box">
                <img
                  src="/assets/img/geneticists.webp"
                  alt="Geneticists"
                  className="w100"
                />
                <h3>Geneticists</h3>
                <p className="op0_5">
                  To interpret complex DNA findings and explain how your genes
                  influence health.
                </p>
              </div>
            </div>
            <div className="col-6 col-lg-3 mb-3" data-aos="fade-up">
              <div className="trusted_by_box">
                <img src="/assets/img/doctors.webp" alt="Doctors" className="w100" />
                <h3>Doctors &amp; Specialists</h3>
                <p className="op0_5">
                  To review your reports, identify risks, and align EPLIMO with
                  your medical care.
                </p>
              </div>
            </div>
            <div className="col-6 col-lg-3 mb-3" data-aos="fade-up">
              <div className="trusted_by_box">
                <img
                  src="/assets/img/nutritionists.webp"
                  alt="Nutritionists"
                  className="w100"
                />
                <h3>Nutritionists &amp; Dieticians</h3>
                <p className="op0_5">
                  To personalize your diet around your genetic absorption
                  patterns and metabolic profile.
                </p>
              </div>
            </div>
            <div className="col-6 col-lg-3 mb-3" data-aos="fade-up">
              <div className="trusted_by_box">
                <img
                  src="/assets/img/health_coaches.webp"
                  alt="Health Coaches"
                  className="w100"
                />
                <h3>Health Coaches</h3>
                <p className="op0_5">
                  To keep you accountable and guide you in fitness, sleep,
                  stress, and lifestyle changes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Experts;
